module.exports = __webpack_public_path__ + "img/ele.50b143f8.png";